module.exports = __webpack_public_path__ + "static/img/401.089007e.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/401.gif
// module id = ASH3
// module chunks = 1